import { useTranslation } from 'react-i18next';
import { POWERED_BY_HOST, POWERED_BY_NAME, POWERED_BY_URL } from '@shared/branding/powered-by';

/**
 * POS-I240: the product's ONE "Powered by" footer line for everything printed from a React view
 * (receipts, payment receipts, previews). On screen the name is a working link; on paper it is plain
 * text plus the host. Product identity, not tenant data: it takes no layout flag, no tenant setting
 * and is never part of the receipt snapshot, so nothing a business configures can remove it.
 * The name and host are Latin and stay left-to-right inside an RTL receipt.
 */
export function PoweredBy({ className = '' }: { className?: string }) {
  const { t } = useTranslation('common');
  const label = t('poweredBy');
  return (
    <p data-powered-by className={`mt-3 text-center text-[10px] leading-snug text-muted-foreground break-words ${className}`}>
      <span className="print:hidden">
        {label}{' '}
        <a href={POWERED_BY_URL} target="_blank" rel="noopener noreferrer" className="underline">
          <bdi dir="ltr">{POWERED_BY_NAME}</bdi>
        </a>
      </span>
      <span className="hidden print:inline">
        {label} <bdi dir="ltr">{POWERED_BY_NAME}</bdi> <bdi dir="ltr">{POWERED_BY_HOST}</bdi>
      </span>
    </p>
  );
}
